/* import __COLOCATED_TEMPLATE__ from './add-custom-mcp-server-modal.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { post } from 'embercom/lib/ajax';

interface Args {
  onModalClose: () => void;
}

export default class AddCustomMcpServerModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare router: $TSFixMe;
  @service declare redirectService: $TSFixMe;

  @tracked serverName = '';
  @tracked serverUrl = '';
  @tracked serverDescription = '';
  @tracked tokenValue = '';
  @tracked tokenName = '';

  constructor(owner: unknown, args: Args) {
    super(owner, args);
  }

  @task({ drop: true })
  *addCustomMCPServer(): TaskGenerator<void> {
    try {
      let response = yield post(
        '/ember/workflow_connector/setup_mcp_actions/add_custom_mcp_server',
        {
          app_id: this.appService.app.id,
          requires_oauth: true,
          server_name: this.serverName,
          server_url: this.serverUrl,
          server_description: this.serverDescription,
        },
      );

      if (response.requires_oauth && response.authorization_url) {
        this.redirectService.redirect(response.authorization_url);
      }
    } catch (error) {
      console.error('Error adding MCP server:', error);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::AddCustomMcpServerModal': typeof AddCustomMcpServerModal;
    'workflow-connector/add-custom-mcp-server-modal': typeof AddCustomMcpServerModal;
  }
}
